import type { Track } from '@/types/tracks';
import type { SfxWithEngagementDocument } from '@music-vine/setlist';

/**
 * Converts a SfxWithEngagementDocument from Typesense to a Track object
 * for compatibility with existing components (HeaderTrackActions, HeaderWaveform, etc.)
 */
export const typesenseSfxToTrack = (doc: SfxWithEngagementDocument): Track => ({
  id: Number(doc.sfx_variant_id),
  name: doc.name,
  slug: doc.sfx_slug,
  current_context: { id: Number(doc.sfx_variant_id) },
  is_explicit_lyrics: doc.is_explicit === 1,
  is_premium: doc.is_premium,
  is_sfx: true,
  sfx_id: doc.sfx_id,
  variant_id: Number(doc.sfx_variant_id),
  artist: {
    id: 0,
    name: doc.contributor_name,
    // contributor_slug indexed by DEV-6303; empty until the backfill lands
    slug: doc.contributor_slug ?? '',
    avatar_image: doc.image
      ? {
          image_aws_url: doc.image,
        }
      : undefined,
  },
  track_version: [
    {
      id: Number(doc.sfx_variant_id),
      version_length: doc.version_length,
      version_precise_length: doc.version_precise_length ?? doc.version_length,
      version_preview_uri: doc.version_preview_uri,
      // SFX doesn't have waveform data in Typesense
      waveform_json: undefined,
    },
  ],
  duration: doc.version_length,
  precise_duration: doc.version_precise_length ?? doc.version_length,
  // Trust-layer fields for the About-this-asset dialog (DEV-6280)
  is_exclusive: doc.is_exclusive,
  set_live: doc.set_live,
});
